var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"width":"100%","height":"100%","border":"none","overflow":"hidden"},attrs:{"id":"iframe3D","src":("/view/index.html?data=" + _vm.dataId + "&placeholder=false")}})}
var staticRenderFns = []

export { render, staticRenderFns }